import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction} from "lodash";
import { initialFilter } from "./WocommCategoriesUIHelper";
const WocommCategoriesUIContext = createContext();

export function useWocommCategoriesUIContext() {
  return useContext(WocommCategoriesUIContext);
}

export const WocommCategoriesUIConsumer = WocommCategoriesUIContext.Consumer;

export function WocommCategoriesUIProvider({ wocommCategoriesUIEvents, children }) {

  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openEditWocommCategoryPage: wocommCategoriesUIEvents.openEditWocommCategoryPage,
    openViewWocommCategoryPage: wocommCategoriesUIEvents.openViewWocommCategoryPage,
   
  };

  return (
    <WocommCategoriesUIContext.Provider value={value}>{children}</WocommCategoriesUIContext.Provider>
  );
}
